export default import.meta.ROLLUP_FILE_URL_uyxRyhxw$2I5bBOwG10uUA;